import {

  GET_END_POINT_DEFINITIONS_SUCCESS,
  ADD_END_POINT_DEFINITION_SUCCESS,
  UPDATE_END_POINT_DEFINITION_SUCCESS,
  UPDATE_END_POINT_DEFINITION,
  DELETE_END_POINT_DEFINITION_SUCCESS,
  API_ERROR
} from "./actionTypes"

const INIT_STATE = {
  recordList: [], //Model Data ve Error
  loading: false,
  error: {},
}

const endPointDefinition = (state = INIT_STATE, action) => {
  switch (action.type) {

    case GET_END_POINT_DEFINITIONS_SUCCESS:
      return {
        ...state,
        recordList: action.payload,
      }

    case ADD_END_POINT_DEFINITION_SUCCESS:
      return {
        ...state,
        recordList: [...state.recordList, action.payload],
      }
    case UPDATE_END_POINT_DEFINITION_SUCCESS:
      return {
        ...state,
        recordList: state.recordList.map(record =>
          record.guid.toString() === action.payload.guid.toString()
            ? { record, ...action.payload }
            : record
        ),
      }

    case DELETE_END_POINT_DEFINITION_SUCCESS:
      return {
        ...state,
        recordList: state.recordList.filter(
          record => record.guid.toString() !== action.payload.toString()
        ),
      }

    case API_ERROR:
      return {
        ...state,
        error: action.payload,
      }

    default:

      return state

  }
}

export default endPointDefinition